import React from 'react';
import { Link } from 'react-router-dom';

// styles
import './style.scss';

const Button = props => {
  const { action, children, classes = 'primary', type = 'link' } = props;

  if (type === 'link') {
    return (
      <Link to={action} className={`btn ${classes}`}>
        {children}
      </Link>
    );
  }

  if (type === 'email') {
    return (
      <a href={`mailto:${action}`} className={`btn ${classes}`}>
        {children}
      </a>
    );
  }

  if (type === 'outside') {
    return (
      <a
        href={action}
        target="_blank"
        rel="noopener nofollow"
        className={`btn ${classes}`}
      >
        {children}
      </a>
    );
  }

  return (
    <button onClick={action} className={`btn ${classes}`}>
      {children}
    </button>
  );
};

export default Button;



// WEBPACK FOOTER //
// ./src/components/common/button/index.js